import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { take } from 'rxjs';

@Component({
    selector: 'app-error-global-page',
    templateUrl: './error-global-page.component.html',
    styleUrls: ['./error-global-page.component.scss'],
    standalone: false
})
export class ErrorGlobalPageComponent {
    public errorDescription = '';
    public errorSubtitle = '';
    public errorTitle = '';

    constructor(private readonly route: ActivatedRoute) {
        this.route.data.pipe(take(1)).subscribe({
            next: (data) => {
                this.errorTitle = data['errorTitle'];
                this.errorSubtitle = data['errorSubtitle'];
            },
        });
    }
}
